import { allAccessories, allServices, appendAvailableTimeSlotsByDate, appendPricedServicesByDate, pricedServicesByDate } from "../state/appState";
import { rootUri } from "@docsndata/thesmartwashltd-bookings-core";
import { loadAvailableTimeSlotsByDate } from "@docsndata/thesmartwashltd-bookings-core";
import { loadPricedServicesByByDate } from "@docsndata/thesmartwashltd-bookings-core";
import { loadAccessories, loadAllServices } from "@docsndata/thesmartwashltd-bookings-core/dist/esm";
function discountPriceFully(ps) {
    return {
        ...ps,
        price: 0
    };
}
export async function loadInviteById(inviteId) {
    const url = `${rootUri()}/v1/thesmartwashltd.com/unusedInviteById?inviteId=${inviteId}`;
    return fetch(url).then(async (response) => {
        if (!response.ok) {
            throw new Error(`Failed to fetch invite '${inviteId}': error code = ${response.status}, error message = ${response.statusText}`);
        }
        const theJson = await response.json();
        if ("invitation" in theJson && Array.isArray(theJson.invitation)) {
            if (theJson.invitation.length === 0) {
                console.error(`Got an empty array for invitation id ${inviteId}`);
                return;
            }
            else if (theJson.invitation.length === 1) {
                return theJson.invitation[0];
            }
        }
        console.error(`Got unexpected response from the invitation endpoint`, { theJson });
        throw new Error(`Got unexpected response from the invitation endpoint`);
    });
}
function sortTimeslots(slots) {
    return [...slots].sort();
}
function inSortedTimeOrder(slots) {
    return Object.keys(slots).reduce((acc, key) => {
        acc[key] = sortTimeslots(slots[key]);
        return acc;
    }, {});
}
export async function loadSlotsAndPrices(fromDateIso, toDateIso, suppliedServiceId) {
    return await Promise.all([
        loadAvailableTimeSlotsByDate(fromDateIso, toDateIso).then(slots => appendAvailableTimeSlotsByDate(inSortedTimeOrder(slots))),
        loadPricedServicesByByDate(fromDateIso, toDateIso, suppliedServiceId).then(appendPricedServicesByDate),
        loadAllServices().then(fetched => allServices.set(fetched)),
        loadAccessories().then(fetched => allAccessories.set(fetched))
    ]);
}
export async function loadUsableCoupon(enteredCouponCode, emailAddress) {
    const url = `${rootUri()}/v1/thesmartwashltd.com/usableCoupon?couponCode=${enteredCouponCode}&emailAddress=${emailAddress}`;
    return fetch(url)
        .then(response => response.json())
        .then((body) => {
        if (!Array.isArray(body) || body.length === 0) {
            return { _type: "error.message", errorMessage: "This coupon is invalid or expired" };
        }
        const first = body[0];
        if ("discountType" in first) {
            return {
                _type: "coupon",
                ...first
            };
        }
        else {
            return { _type: "error.message", errorMessage: "Something went wrong checking the coupon" };
        }
    });
}
export function applyPercentageDiscount(percentageDiscount) {
    if (percentageDiscount !== 100) {
        throw new Error(`Unable supports 100% discount for now, got ${percentageDiscount}`);
    }
    pricedServicesByDate.update(priced => {
        return Object.keys(priced).reduce((acc, key) => {
            const pricedServices = priced[key];
            acc[key] = pricedServices.map(ps => discountPriceFully(ps));
            return acc;
        }, {});
    });
}
